import { Component, computed, inject, input, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { JOBS_URL } from '../../../../shared/consts/shared.const';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-expired-job',
  standalone:true,
  imports: [RouterLink, TranslocoModule],
  template: `
   
<div class="bg-[#eee] relative min-h-[100vh] flex " *transloco="let t; currentLang as currentLang">
  <div class=" sm:py-5 sm:px-2 mx-auto xl-width-full lg-width-full bg-[#eee] rounded">
    <div class="bg-white max-w-4xl flex flex-col items-center min-h-[100vh] rounded">
    <div class="px-4 py-3 text-start  py-2.5 rounded-md  min-w-full">
        <button [routerLink]="jobs_url" [queryParams]="{isBack: true}" [class.hidden]="hideAdd()" class=" cursor-pointer">
          <span class="flex gap-1.5 items-center cursor-pointer font-semibold text-[#475467]">
            <img [src]="environment.homeImageUrl + 'icon-down.svg'" class="rotate-90 w-5 h-5"/>
            <span>{{t('jobList')}}</span>
          </span>
        </button>
      </div>
      <div class="flex justify-center">
        <img [src]="environment.homeImageUrl + 'expired-img.svg'" />
      </div>
      <div class="-mt-28 flex flex-col items-center gap-2 max-w-[372px] text-center">
          <p class="text-[#101828] text-lg font-semibold">{{t('jobNotAvailableTitle')}}</p>
          <p class="text-[#344054] text-sm mb-6">{{ t(text()) }}</p>
          <a routerLink="/" class="cursor-pointer  px-4 py-2.5 bg-[#C63C92] text-white rounded-lg mr-2">{{t('goToJobList')}} <span class="icon-angle-right-long text-white"></span></a>
        </div>
      
    </div>
  </div>
</div>


  `,
  styles: `
      @media (min-width: 992px) and (max-width: 1199px) {
      .sticky-bar {
          position: sticky;
      }
      .lg-width{
        width:760px;
      }
      .lg-width-full{
        width:970px;
      }

    }

    @media (min-width: 1200px){
      .xl-width{
        width:940px;
      }
      .xl-width-full{
        width:1140px;
      }
    }
    `
})
export class ExpiredJobComponent{
  environment = environment;
  private route = inject(ActivatedRoute)
  readonly text = input<string>('')
  private transloco = inject(TranslocoService)
  private queryParams = toSignal(this.route.queryParams, { initialValue: {} });
  jobs_url = JOBS_URL
  hideAdd = computed(() => {
    const params = this.queryParams() as { [key: string]: any };
    return params['src'] === 'recruiter.bdjobs.com';
  });

}
